import { render, staticRenderFns } from "./SelectEvent.vue?vue&type=template&id=8e2c7bc6&scoped=true"
import script from "./SelectEvent.vue?vue&type=script&lang=js"
export * from "./SelectEvent.vue?vue&type=script&lang=js"
import style0 from "./SelectEvent.vue?vue&type=style&index=0&id=8e2c7bc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2c7bc6",
  null
  
)

export default component.exports